import styled, { css } from "styled-components";
import * as Tooltip from "../../../../../common-deprecated/styles/toyota/Tooltip";
import { theme } from "../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { IconWrapper } from "../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { getBreakpoint } from "../../../../../common-deprecated/themes/common";
import * as Button from "../../../../../common-deprecated/styles/toyota/Button";

export const Wrapper = styled.div`
    text-align: start;
`;

export const Header = styled.header``;

export const Title = styled.h3.attrs(() => ({
    className: "t-gamma-text",
}))`
    margin: ${theme.space[3]}px 0;
    padding: 0 ${theme.space[1]}px;
    font-size: 2rem;
    text-align: start;

    @media ${getBreakpoint("up", "md")} {
        padding: 0;
    }

    @media ${getBreakpoint("up", "lg")} {
        font-size: 2.8rem;
    }
`;

export const InnerCol = styled.div`
    width: 100%;
    padding: ${theme.space[3]}px 0;
`;

export const Label = styled.div.attrs(() => ({
    className: "t-milli-text",
}))`
    margin-bottom: ${theme.space[2]}px;
    text-align: start;
    color: ${theme.colors.grey4};
`;

type DescriptionType = { open: boolean; showReadMore: boolean; heightLimit: number; fullHeight: number };

export const Description = styled.span.attrs(() => ({
    className: "t-milli-text",
}))<DescriptionType>`
    margin-top: ${theme.space[2]}px;
    color: ${theme.colors.grey4};

    ${({ showReadMore, heightLimit }) =>
        showReadMore &&
        css`
            display: block;
            position: relative;
            max-height: ${heightLimit}px;
            transition: max-height 0.3s;
            overflow: hidden;
            &:after {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                height: 40px;
                content: "";
                background: linear-gradient(transparent, white);
                transition: opacity 0.3s;
                opacity: 1;
            }
        `};
    ${({ open, fullHeight }) =>
        open &&
        // 20px padding just to be safe
        css`
            display: block;
            max-height: ${fullHeight + 20}px !important;
            padding-bottom: ${theme.space[2]}px;
            overflow: hidden;
            &:after {
                display: none;
                opacity: 0;
            }
        `};
`;

export const Value = styled.div.attrs(() => ({
    className: "t-base-text",
}))<{ isPdf?: boolean }>`
    display: ${({ isPdf }) => (isPdf ? "block" : "flex")};
    position: relative; /* for tooltip */
    align-items: center;
    min-height: 25px;
    text-align: start;
    color: ${theme.colors.primaryBlack};

    span {
        font-family: ${theme.fonts.base};
        font-size: 1.3rem;
        color: ${theme.colors.grey4};
    }

    ${IconWrapper} {
        margin-right: ${theme.space[1]}px;
    }

    ${Button.Link} {
        margin-top: -3px;
        line-height: 2rem;
    }

    ${Tooltip.Wrapper} {
        width: 400px;
    }

    html[dir="rtl"] & {
        ${IconWrapper} {
            margin-left: ${theme.space[1]}px;
            margin-right: 0;
        }
    }
`;

export const ReadMoreLess = styled.button.attrs(() => ({
    className: "t-milli-text",
}))`
    display: flex;
    background: transparent;
    border: none;
`;
